module.exports = __webpack_public_path__ + "img/up-angle.4c39c1c0.svg";